export default [
  {
    path: '/jobs/booking',
    name: 'jobs-booking',
    component: () => import('@/views/modules/jobs/staffBooking'),
    meta: {
      requiresAuth: true,
      title:'Job Booking',
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Booking' }
      ]
    },
    
  }, 

  {
    path: '/jobs/booking-bulk',
    name: 'jobs-booking-bulk',
    component: () => import('@/views/modules/jobs/bulkBooking'),
    meta: {
      requiresAuth: true,
      title:'Job Booking Bulk',
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Bulk Booking' }
      ]
    },
    
  }, 

  {
    path: '/jobs/enquiry',
    name: 'jobs-enquiry',
    component: () => import('@/views/modules/jobs/enquiry'),
    meta: {
      requiresAuth: true,
      title:'Job Enquiry',
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Job Enquiry' }
      ]
    },
    children:[
      {
        path: '/jobs/enquiry/:id/detailed',
        name: 'jobs-enquiry-detailed',
        props: true,
        component: () => import('@/views/modules/jobs/enquiryDetailed'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Job Detailed',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Jobs Enquiry', link: '/jobs-enquiry' },
            { text: 'Detailed' }
          ]
        }
      },
    ]
    
  }, 

  {
    path: '/jobs/awaiting-allocation',
    name: 'jobs-awaiting-allocation',
    component: () => import('@/views/modules/jobs/awaitingAllocation'),
    meta: {
      requiresAuth: true,
      title:'Jobs Awaiting Allocation',
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Jobs Awaiting Allocation' }
      ]
    },
    children:[
      {
        path: '/jobs/awaiting-allocation-create/:id/create',
        props: true,
        name: 'jobs-awaiting-allocation-create',
        component: () => import('@/views/modules/jobs/awaitingAllocationCreate'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Allocate',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Awaiting Allocation', link: '/jobs/awaiting-allocation' },
            { text: 'Allocate' }
          ]
        }
      },
    ]
  },


  {
    path: '/jobs/repair',
    name: 'jobs-repair',
    component: () => import('@/views/modules/jobs/repair'),
    meta: {
      requiresAuth: true,
      title:'Jobs Repair',
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Jobs Repair' }
      ]
    },
    children:[
      {
        path: '/jobs/repair-assessment-create/:id/create',
        props: true,
        name: 'jobs-repair-assessment-create',
        component: () => import('@/views/modules/jobs/repairAssessmentCreate'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Assessment',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Repairs', link: '/jobs/repair' },
            { text: 'Assessment' }
          ]
        }
      },
      {
        path: '/jobs/repair-repaired-create/:id/create',
        props: true,
        name: 'jobs-repair-repaired-create',
        component: () => import('@/views/modules/jobs/repairRepairedCreate'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Repair',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Repairs', link: '/jobs/repair' },
            { text: 'Repair' }
          ]
        }
      },
    ]
  },


  {
    path: '/jobs/quotations',
    name: 'jobs-quotations',
    component: () => import('@/views/modules/jobs/quotations'),
    meta: {
      requiresAuth: true,
      title:'Jobs Quotation',
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Jobs Quotation' }
      ]
    },
    children:[
      {
        path: '/jobs/quotation/:id/review',
        props: true,
        name: 'jobs-quotations-review',
        component: () => import('@/views/modules/jobs/quotationReview'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Review',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Quotations', link: '/jobs/quotations' },
            { text: 'Review' }
          ]
        }
      },
      {
        path: '/jobs/quotations/:id/process',
        props: true,
        name: 'jobs-quotations-process',
        component: () => import('@/views/modules/jobs/quotationProcess'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Process',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Quotations', link: '/jobs/quotations' },
            { text: 'Process' }
          ]
        }
      },
      {
        path: '/jobs/quotations/:id/show',
        props: true,
        name: 'jobs-quotations-show',
        component: () => import('@/views/modules/jobs/quotationShow'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'View Quotation',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Quotations', link: '/jobs/quotations' },
            { text: 'View Quotation' }
          ]
        }
      },
      {
        path: '/jobs/quotations/:id/edit',
        props: true,
        name: 'jobs-quotations-edit',
        component: () => import('@/views/modules/jobs/quotationEdit'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Edit Quotation',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Quotations', link: '/jobs/quotations' },
            { text: 'Edit Quotation' }
          ]
        }
      },
    ]
  },
  {
    path: '/jobs/parts-requisition',
    name: 'jobs-parts-requisition',
    component: () => import('@/views/modules/jobs/partsRequisition'),
    meta: {
      requiresAuth: true,
      title:'Jobs Parts Requisition',
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Jobs Part Requisition' }
      ]
    },
  },
  {
    path: '/jobs/parts-return',
    name: 'jobs-parts-return',
    component: () => import('@/views/modules/jobs/partsReturn'),
    meta: {
      requiresAuth: true,
      title:'Jobs Parts Return',
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Jobs Part Return' }
      ]
    },
  },
  {
    path: '/jobs/quality-control',
    name: 'jobs-quality-control',
    component: () => import('@/views/modules/jobs/qualityControl'),
    meta: {
      requiresAuth: true,
      title:'Jobs Quality Control',
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Jobs Quality Control' }
      ]
    },
    children:[
      {
        path: '/jobs/quality-control-create/:id/create',
        props: true,
        name: 'jobs-quality-control-create',
        component: () => import('@/views/modules/jobs/qualityControlCreate'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Quality Control',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Quality Control', link: '/jobs/quality-control' },
            { text: 'Quality Control' }
          ]
        }
      },
    ]
  },
  {
    path: '/jobs/device-replace',
    name: 'jobs-device-replace',
    component: () => import('@/views/modules/jobs/deviceReplace'),
    meta: {
      requiresAuth: true,
      title:'Jobs Device Replace',
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Jobs Device Replace' }
      ]
    },
    children:[
      {
        path: '/jobs/quality-device-replace/:id/create',
        props: true,
        name: 'jobs-device-replace-create',
        component: () => import('@/views/modules/jobs/deviceReplaceCreate'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Device Replace',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Device Replace', link: '/jobs/device-replace' },
            { text: 'Device Replace' }
          ]
        }
      },
    ]
  },

  {
    path: '/jobs/update',
    name: 'jobs-update',
    component: () => import('@/views/modules/jobs/update'),
    meta: {
      requiresAuth: true,
      title:'Jobs Update',
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Jobs Update' }
      ]
    },
    children:[
      {
        path: '/jobs/update/:id/create',
        props: true,
        name: 'jobs-update-create',
        component: () => import('@/views/modules/jobs/updateCreate'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Job Update',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Jobs Update', link: '/jobs/update' },
            { text: 'Job Update' }
          ]
        }
      },
    ]
  },

  {
    path: '/jobs/cancel',
    name: 'jobs-cancel',
    component: () => import('@/views/modules/jobs/cancel'),
    meta: {
      requiresAuth: true,
      title:'Jobs Cancel',
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Jobs Cancel' }
      ]
    },
    children:[
      {
        path: '/jobs/cancel/:id/create',
        props: true,
        name: 'jobs-cancel-create',
        component: () => import('@/views/modules/jobs/cancelCreate'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Job Cancel',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Jobs Cancel', link: '/jobs/jobs-cancel' },
            { text: 'Job Cancel' }
          ]
        }
      },
    ]
  },

  {
    path: '/jobs/rnr',
    name: 'jobs-rnr',
    component: () => import('@/views/modules/jobs/rnr'),
    meta: {
      requiresAuth: true,
      title:'Jobs RNR',
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Jobs RNR' }
      ]
    },
    children:[
      {
        path: '/jobs/rnr/:id/create',
        props: true,
        name: 'jobs-rnr-create',
        component: () => import('@/views/modules/jobs/rnrCreate'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Device Replace',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Jobs RNR', link: '/jobs/rnr' },
            { text: 'Job RNR' }
          ]
        }
      },
    ]
  },

  {
    path: '/jobs/defray',
    name: 'jobs-defray',
    component: () => import('@/views/modules/jobs/defray'),
    meta: {
      requiresAuth: true,
      title:'Jobs Defray',
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Jobs Defray' }
      ]
    },
    children:[
      {
        path: '/jobs/defray/:id/create',
        props: true,
        name: 'jobs-defray-create',
        component: () => import('@/views/modules/jobs/defrayCreate'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Job Defray',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Jobs Defray', link: '/jobs/defray' },
            { text: 'Job Defray' }
          ]
        }
      },
    ]
  },

  {
    path: '/jobs/reassess',
    name: 'jobs-reassess',
    component: () => import('@/views/modules/jobs/reassess'),
    meta: {
      requiresAuth: true,
      title:'Jobs Reassess',
      layout: 'app',
      breadcrumb: [
        { text: 'Home', to: { name: "home" }  },
        { text: 'Jobs Reassess' }
      ]
    },
    children:[
      {
        path: '/jobs/reassess/:id/create',
        props: true,
        name: 'jobs-reassess-create',
        component: () => import('@/views/modules/jobs/reassessCreate'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Job Reassess',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Jobs Reassess', link: '/jobs/reassess' },
            { text: 'Job Reassess' }
          ]
        }
      },
    ]
  }

]